module.exports = __webpack_public_path__ + "static/media/hall-P7.0d802506.svg";